/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCustomerCenter
 */
export interface MstCustomerCenter {
    /**
     * 
     * @type {number}
     * @memberof MstCustomerCenter
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    orgCustomerId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    orgCustomerCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    customerCenterName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    customerCenterAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    customerCenterGln: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCustomerCenter
     */
    customerCenterId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    transportOrgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    remarks: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCustomerCenter
     */
    deleteFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomerCenter
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    insertUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomerCenter
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomerCenter
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenter
     */
    deleteUser: string | null;
}

/**
 * Check if a given object implements the MstCustomerCenter interface.
 */
export function instanceOfMstCustomerCenter(value: object): value is MstCustomerCenter {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('orgCustomerId' in value) || value['orgCustomerId'] === undefined) return false;
    if (!('orgCustomerCenterId' in value) || value['orgCustomerCenterId'] === undefined) return false;
    if (!('customerCenterName' in value) || value['customerCenterName'] === undefined) return false;
    if (!('customerCenterAddress' in value) || value['customerCenterAddress'] === undefined) return false;
    if (!('customerCenterGln' in value) || value['customerCenterGln'] === undefined) return false;
    if (!('customerCenterId' in value) || value['customerCenterId'] === undefined) return false;
    if (!('transportOrgCenterId' in value) || value['transportOrgCenterId'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    return true;
}

export function MstCustomerCenterFromJSON(json: any): MstCustomerCenter {
    return MstCustomerCenterFromJSONTyped(json, false);
}

export function MstCustomerCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCustomerCenter {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'orgCustomerId': json['org_customer_id'],
        'orgCustomerCenterId': json['org_customer_center_id'],
        'customerCenterName': json['customer_center_name'],
        'customerCenterAddress': json['customer_center_address'],
        'customerCenterGln': json['customer_center_gln'],
        'customerCenterId': json['customer_center_id'],
        'transportOrgCenterId': json['transport_org_center_id'],
        'remarks': json['remarks'],
        'deleteFlg': json['delete_flg'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
    };
}

export function MstCustomerCenterToJSON(json: any): MstCustomerCenter {
    return MstCustomerCenterToJSONTyped(json, false);
}

export function MstCustomerCenterToJSONTyped(value?: MstCustomerCenter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'org_customer_id': value['orgCustomerId'],
        'org_customer_center_id': value['orgCustomerCenterId'],
        'customer_center_name': value['customerCenterName'],
        'customer_center_address': value['customerCenterAddress'],
        'customer_center_gln': value['customerCenterGln'],
        'customer_center_id': value['customerCenterId'],
        'transport_org_center_id': value['transportOrgCenterId'],
        'remarks': value['remarks'],
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
    };
}

